(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-gallery"] && !Shopify.designMode) return;
  try {
    

/* OPEN LIGHTBOX */
document.querySelectorAll('.ws-gallery-shirt').forEach(item => {
  item.addEventListener('click', () => {
    const front = item.dataset.front;
    const combined = item.dataset.combined;
    const slug = item.dataset.slug;

    const img = document.getElementById('wsLightboxFront');
    const lightbox = document.getElementById('wsLightbox');

    img.src = combined && combined !== "" ? combined : front;

    history.replaceState(null, '', `?design=${slug}`);

    lightbox.style.display = 'flex';
  });
});

/* CLOSE LIGHTBOX */
function closeLightbox() {
  document.getElementById('wsLightbox').style.display = 'none';
  history.replaceState(null, '', window.location.pathname);
}

document.getElementById('wsLightboxClose').addEventListener('click', closeLightbox);

document.getElementById('wsLightbox').addEventListener('click', e => {
  if (e.target.id === 'wsLightbox') closeLightbox();
});

/* AUTO-OPEN VIA URL */
const params = new URLSearchParams(window.location.search);
const design = params.get('design');

if (design) {
  const item = document.querySelector(`.ws-gallery-shirt[data-slug="${design}"]`);
  if (item) item.click();
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-info-grid"] && !Shopify.designMode) return;
  try {
    

/* OPEN LIGHTBOX */
document.querySelectorAll('.ws-info-item, .ws-info-details-link').forEach(el => {
  el.addEventListener('click', e => {
    const id = el.dataset.id || el.dataset.open;
    const slug = el.dataset.slug;

    if (!id) return;

    document.body.style.overflow = 'hidden';
    document.getElementById(`wsLightbox-${id}`).style.display = 'block';

    if (slug) {
      history.replaceState(null, '', `?info=${slug}`);
    }
  });
});

/* CLOSE LIGHTBOX */
function wsCloseLightbox(id) {
  document.getElementById(`wsLightbox-${id}`).style.display = 'none';
  document.body.style.overflow = '';
  history.replaceState(null, '', window.location.pathname);
}

document.querySelectorAll('.ws-info-lightbox-close').forEach(btn => {
  btn.addEventListener('click', () => wsCloseLightbox(btn.dataset.close));
});

/* CLOSE ON BACKDROP CLICK */
document.querySelectorAll('.ws-info-lightbox').forEach(box => {
  box.addEventListener('click', e => {
    if (e.target.classList.contains('ws-info-lightbox')) {
      const id = box.id.replace('wsLightbox-', '');
      wsCloseLightbox(id);
    }
  });
});

/* ESC CLOSE */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.ws-info-lightbox').forEach(box => {
      const id = box.id.replace('wsLightbox-', '');
      wsCloseLightbox(id);
    });
  }
});

/* AUTO-OPEN VIA URL */
const params = new URLSearchParams(window.location.search);
const infoSlug = params.get('info');

if (infoSlug) {
  const item = document.querySelector(`.ws-info-item[data-slug="${infoSlug}"]`);
  if (item) item.click();
}


  } catch(e) { console.error(e); }
})();
})();
